import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    title: _ctx.title,
    validTitle: _ctx.validTitle,
    hideNext: true,
    previousDisabled: true,
    onValid: _ctx.valid,
    onClose: _ctx.close,
    width: "800px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.description), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "validTitle", "onValid", "onClose"]))
}